import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "../appleBusinessManager/logo.svg";
import {
  CLIENT_CONTEXT,
  endpoint,
  publicEnvVars,
  usageHint,
} from "../vnc/shared";

export const appleRemoteDesktop = defineConnector({
  identifier: "appleRemoteDesktop",
  name: "Apple Remote Desktop",
  tagLine: "View and control a Mac desktop",
  keywords: "vnc rfb mac macos apple remote desktop screen sharing computer",
  logo,
  tags: ["it", "custom"],
  protocol: "vnc",
  defaultUrlPattern: () => "",
  customizeStepHandledInline: true,
  auth: customAuth("vnc"),
  aiContext: `Mac screen control using Apple Remote Desktop’s legacy type-30 Diffie-Hellman username-and-password authentication over VNC, with 1024-bit DH groups. Newer RSA/SRP authentication and Remote Desktop management tasks are not supported. Use the Mac account allowed to use Screen Sharing or Remote Management. ${CLIENT_CONTEXT}`,
  steps: [
    {
      title: "Connect to a Mac",
      items: [
        {
          kind: "input",
          label: "Name",
          required: true,
          defaultValue: "Apple Remote Desktop",
          target: { kind: "connectedApp", field: "name" },
        },
        {
          kind: "hostname",
          label: "Host",
          required: true,
          placeholder: "mac.lan",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Port",
          required: true,
          defaultValue: "5900",
          target: { kind: "configuration", field: "port" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          helperText:
            "The Mac account allowed to use Screen Sharing or Remote Management.",
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
        {
          kind: "markdown",
          content:
            "On the Mac, enable Screen Sharing or Remote Management and allow this account. Enter the Mac account’s username and password. The Mac must support legacy Apple Remote Desktop authentication. Use a tunnel or a trusted private network; this connector does not encrypt desktop traffic.",
        },
      ],
    },
  ],
  connectionTest: { protocol: "vnc", connectionString: endpoint },
  publicEnvVars,
  usageHint,
});
